import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  errorFetchingExternalInventoryTitle: {
    defaultMessage: 'External inventory error',
    id: '85snu9',
    description: 'Error fetching external inventory',
  },
  errorFetchingExternalInventoryContent: {
    defaultMessage: 'Unable to load external inventory. Please try again.',
    id: 'Gn7MaM',
    description: 'Error fetching external inventory',
  },
});
